module.exports = __webpack_public_path__ + "assets/retina_PerimeterBisectorDetailed.64a668391f8b0a3f0174ccc09d6b2c65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_PerimeterBisectorDetailed.png
// module id = 704
// module chunks = 0